import Loading from "../Loading";
import { useSelector } from "react-redux";

export const ShowOrder = ({setShowOrder}) => {
  const { htmlContent, loading } = useSelector((state) => state.orderFile);

  const handleCloseImage = (e) => {
    e.stopPropagation();
    setShowOrder(false);
  };

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000073] z-50 overflow-auto show-order-overlay" onClick={handleCloseImage}>
      {loading && <Loading />}
      <div className="w-[1300px] relative m-auto my-[15%] bg-white rounded-lg py-[15px] px-[15px] show-order-modal">
        {htmlContent && typeof htmlContent === 'string' && htmlContent.trim() !== '' && <div dangerouslySetInnerHTML={{ __html: htmlContent }} />}
      </div>
    </div>
  );
}